import React, { useContext, useEffect, useState } from "react";
import styles from "../../../form.module.css";
import {
  Button,
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import useFetch from "../../../../../hooks/useFetch";
import useToast from "../../../../../hooks/useToast";
import {
  eDocType,
  eFORM_FOR,
  eFORMSTATUS,
  eResultCode,
  eYES_OR_NO,
  INPUT_LENGTH,
} from "../../../../../utils/enum";
import { ToastOpen, ToastType } from "../../../../../state/toast/slice";
import { CloseOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import Text, { LanguageContext } from "../../../../../context/language-context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "../../../../../context";
import {
  GetFormData,
  getTimeline,
  updateField,
  UploadDocs,
} from "../../../../../utils/api.constant";
import AuthUtil from "../../../../../utils/auth";
import { FaCheck } from "react-icons/fa";
import { TFormProps } from "../../../../../types";
import { LoaderContext } from "../../../../../context/loader";
import EncryptUtils from "../../../../../utils/encrypt";
import Utils from "../../../../../utils/index";
import {
  allowOnlyNumericInput_onKeyDown,
  disableFutureDates_on_input_date_max,
  validateFile,
} from "../../../../../utils/input.validator";
import { Regex } from "../../../../../utils/validation";
import { Table } from "antd";
import type { TableProps } from "antd/es/table";
import {
  getNumberInLanguage,
  stringDateInLanguage,
} from "../../../../../utils/helperFunctions";
import dayjs from "dayjs";
const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StudentPartOne = ({
  disabled,
  currentFormId,
  currentUfmId,
}: TFormProps) => {
  const [form] = Form.useForm();
  const { post } = useFetch();
  const { onShowToast } = useToast();
  const [searchParams, setSearchParams] = useSearchParams();
  const [formId, setFormId] = useState<string | null>(null);
  const [ufmId, setUfmId] = useState<string | null>(null);
  const [formFor, setFormFor] = useState<string | null>(null);
  const { user } = useContext(UserContext);
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);
  const [documentsData, setDocumentsData] = useState<any>([]);
  const [timeLine, setTimeLine] = useState<any>([]);
  const [attachmentId, setAttachmentId] = useState<string | null>(null);
  const [signatureId, setSignatureId] = useState<string | null>(null);
  const navigate = useNavigate();
  const DROPDOWN_PLACEHOLDER = Text({
    tid: "DROPDOWN_PLACEHOLDER",
    def: "DROPDOWN_PLACEHOLDER",
  });

  // Loader Context For show Loader
  const contextForLoader = useContext(LoaderContext);
  const { isLoading, setIsLoading } = contextForLoader as any;

  const vedMapping = {
    [Text({ tid: "RIGVEDA", def: "Rigveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_SHAKALA", def: "Shakala" }),
        Text({ tid: "SHAKHA_BASHKALA", def: "Bashkala" }),
        Text({ tid: "SHAKHA_SHANKHAYANA", def: "Shankhayana" }),
      ],
    },
    [Text({ tid: "SHUKLA_YAJURVEDA", def: "Shukla Yajurveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_KANVA", def: "Kanva" }),
        Text({ tid: "SHAKHA_MADHYANDINA", def: "Madhyandina" }),
      ],
    },
    [Text({ tid: "KRISHNA_YAJURVEDA", def: "Krishna Yajurveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_TAITTIRIYA", def: "Taittiriya" }),
        Text({ tid: "SHAKHA_MAITRAYANI", def: "Maitrayani" }),
      ],
    },
    [Text({ tid: "SAMAVEDA", def: "Samaveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_KAUTHUMA", def: "Kauthuma" }),
        Text({ tid: "SHAKHA_JAIMINIYA", def: "Jaiminiya" }),
        Text({ tid: "SHAKHA_RANAYANIYA", def: "Ranayaniya" }),
      ],
    },
    [Text({ tid: "ATHARVAVEDA", def: "Atharvaveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_SHAUNAKA", def: "Shaunaka" }),
        Text({ tid: "SHAKHA_PAIPPALADA", def: "Paippalada" }),
        Text({ tid: "SHAKHA_SHAKALA", def: "Shakala" }),
      ],
    },
  };

  const [vedOptions, setVedOptions] = useState<any>(vedMapping);
  const [samvedShakhaOptions, setSamvedShakhaOptions] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [applyPdfStyles, setApplyPdfStyles] = useState(false);

  useEffect(() => {
    if (searchParams) {
      const formId = EncryptUtils.decrypt(searchParams.get("id") || "");
      const ufmId = EncryptUtils.decrypt(searchParams.get("ufmid") || "");
      const formFor = EncryptUtils.decrypt(searchParams.get("ff") || "");
      setFormId(formId);
      setUfmId(ufmId);
      setFormFor(formFor);
    }
    if (currentFormId && currentUfmId) {
      setFormId(EncryptUtils.decrypt(currentFormId));
      setUfmId(EncryptUtils.decrypt(currentUfmId));
    }
  }, [searchParams, currentFormId, currentUfmId]);

  useEffect(() => {
    if (formFor === eFORM_FOR.YOURSELF.toString()) {
      const autoFillData = {
        STUDENT_PT1_Q1: user?.fullName,
        STUDENT_PT1_Q28: user?.fullName,
        STUDENT_PT1_Q30: user?.fullName,
        STUDENT_PT1_Q2: user?.aadhaarCardNumber,
        STUDENT_PT1_Q3: user?.dateOfBirth,
        STUDENT_PT1_Q5: user?.fatherName,
        STUDENT_PT1_Q11: user?.mobileNumber,
        STUDENT_PT1_Q12: user?.emailId,
      };
      form.setFieldsValue(autoFillData);
      handleFieldChange("", "", autoFillData);
    }
  }, [formFor, user]);

  const handleFieldChange = async (
    field: string,
    value: any,
    bulkPayload?: any,
    isSubmitted?: boolean
  ) => {
    if (formId?.length && ufmId?.length) {
      setIsSubmitting(true);
      try {
        const payload: any = {
          data: {
            id: formId,
            userFormMappingId: ufmId,
          },
        };
        if (field.length > 0) {
          const trimmedValue = value.trim();
          if (trimmedValue.length) {
            payload.data[field] = trimmedValue || "";
          } else {
            form.setFieldValue(field, "");
            return;
          }
        }
        if (bulkPayload) {
          payload.data = {
            ...payload.data,
            ...bulkPayload,
          };
        }
        if (isSubmitted) {
          payload.data.isSubmitted = true;
        }
        const response = await post(updateField, payload);
        const { dataResponse } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode == eResultCode.SUCCESS) {
          if (isSubmitted) {
            onShowToast({
              type: ToastType.success,
              title: <FaCheck />,
              position: ToastOpen.leftBottom,
              content: "Form Submitted Successfully!",
            });
            setTimeout(() => {
              navigate("/");
            }, 1000);
          }
        } else if (returnCode == eResultCode.INVALID_REQUEST) {
          onShowToast({
            type: ToastType.error,
            title: <ExclamationCircleOutlined />,
            position: ToastOpen.leftBottom,
            content: description,
          });
        }
      } catch (error) {
        console.error("Student Form 1 Error : ", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const [isUploading, setIsUploading] = useState<Boolean>(false);

  const uploadDocument = async (
    file: File,
    type: eDocType,
    documentName?: string
  ) => {
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("docType", type.toString());
      formData.append("ufmId", ufmId || "");
      formData.append("userId", user?.id?.toString() || "");
      formData.append("labelName", documentName || "");
      formData.append("currentStage", eFORMSTATUS.STAGE1INPROGRESS.toString());
      const response = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_BASEURL}${UploadDocs}`,
        {
          method: "POST",
          body: formData,
          headers: { ...AuthUtil.getToken() },
        }
      );
      const res = await response.json();
      const { data, dataResponse } = res;
      const { returnCode, description } = dataResponse;

      if (returnCode == eResultCode.SUCCESS) {
        setIsUploading(false);
        if (documentName === "STUDENT_PT1_Q29") {
          setSignatureId(data.docUrl.toString());
        } else {
          setAttachmentId(data.docUrl.toString());
        }
      } else {
        console.error("Failed to upload images", response.statusText);
      }
    } catch (error) {
      setIsUploading(false);
      console.error("Student Form 1 Error", error);
    }
  };

  useEffect(() => {
    if (attachmentId) {
      handleFieldChange("STUDENT_PT1_Q20_EXAM_CERTIFICATE", attachmentId);
    }
    if (signatureId) {
      handleFieldChange("STUDENT_PT1_Q29", signatureId);
    }
  }, [attachmentId, signatureId]);

  useEffect(() => {
    setVedOptions(vedMapping);
  }, [userLanguage]);

  const getFormData = async () => {
    setIsLoading(true);
    try {
      const payload: any = {
        data: {
          id: formId,
          userFormMappingId: ufmId,
          isPtOne: true,
          year: 2025,
        },
      };
      const response = await post(GetFormData, payload);
      const { dataResponse, data } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode == eResultCode.SUCCESS) {
        const formData = Object.values(data?.studentPt1Forms || {}).every(
          (value) => value === null
        )
          ? {}
          : data?.studentPt1Forms || {};

        form.setFieldsValue({
          ...formData,
          STUDENT_PT1_Q20_EXAM_CERTIFICATE: "",
          STUDENT_PT1_Q20_EXAM_YEAR: dayjs(
            formData.STUDENT_PT1_Q20_EXAM_YEAR,
            "YYYY"
          ).isValid()
            ? dayjs(formData.STUDENT_PT1_Q20_EXAM_YEAR, "YYYY")
            : formData.STUDENT_PT1_Q20_EXAM_YEAR,
          STUDENT_PT1_Q29: "",
        });
        setDocumentsData(data?.documents);
      }
    } catch (error) {
      console.error("Student 1 Form Error", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (formId?.length && ufmId?.length) {
      getFormData();
    }
  }, [formId, ufmId]);

  const LengthCounter: React.FC<{ form: any; fieldName: string }> = ({
    form,
    fieldName,
  }) => {
    // Use useWatch to get real-time updates for the field value
    const fieldValue = Form.useWatch(fieldName, form);

    return (
      <div className='length_counter'>
        {(fieldValue || "").length}/{INPUT_LENGTH.TEXTAREA_LENGTH}
      </div>
    );
  };

  const handleGeneratePDF = () => {
    setApplyPdfStyles(true);
    setTimeout(() => {
      Utils.generatePDF(
        "student_part_one_affidavit",
        "Student_part_one_affidavit"
      );
      setApplyPdfStyles(false);
    }, 0);
  };

  const getTimelineData = async () => {
    try {
      const response = await post(getTimeline, {});
      const { dataResponse, data } = response;
      const { returnCode } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        setTimeLine(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setSamvedShakhaOptions(() => {
      return Object.values(vedMapping).flatMap((item) => item.vedashakhas);
    });
    getTimelineData();
  }, []);

  return (
    <div
      id='studentFormPart1'
      className={`${styles.formWrapper} studentTeacherSchoolFormWrapper`}
    >
      <Form
        {...formItemLayout}
        form={form}
        name='register'
        onFinish={() => handleFieldChange("", "", null, true)}
        initialValues={{
          STUDENT_PT1_Q16: null,
          STUDENT_PT1_Q17: null,
        }}
        scrollToFirstError
        layout='vertical'
      >
        {/* Form */}
        <Row>
          <Col>
            <Typography.Title level={3}>
              {Text({
                tid: "STUDENT_PART_1_FORM_HEADING",
                def: "STUDENT_PART_1_FORM_HEADING",
              })}
            </Typography.Title>
            {!disabled && (
              <Typography.Text type='danger'>
                {Text({
                  tid: "all_fields_are_mandatory",
                  def: "All fields are mandatory!",
                })}
              </Typography.Text>
            )}
          </Col>
        </Row>
        {/* 1. Name */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q1'
              label={Text({
                tid: "STUDENT_PT1_Q1",
                def: "Name",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) => {
                  handleFieldChange("STUDENT_PT1_Q1", e.target.value);
                  handleFieldChange("STUDENT_PT1_Q28", e.target.value);
                  handleFieldChange("STUDENT_PT1_Q30", e.target.value);
                  form.setFieldValue("STUDENT_PT1_Q28", e.target.value);
                  form.setFieldValue("STUDENT_PT1_Q30", e.target.value);
                }}
                onChange={(e) => {
                  form.setFieldValue("STUDENT_PT1_Q28", e.target.value);
                  form.setFieldValue("STUDENT_PT1_Q30", e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 2. Father's name */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q5'
              label={Text({
                tid: "STUDENT_PT1_Q5",
                def: "Father's name",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q5", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 3. Mother's name */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q6'
              label={Text({
                tid: "STUDENT_PT1_Q6",
                def: "Mother's name",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q6", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 4. DOB */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q3'
              label={Text({
                tid: "STUDENT_PT1_Q3",
                def: "Date of birth",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                type='date'
                disabled={disabled}
                max={disableFutureDates_on_input_date_max()}
                onClick={(e) => e.currentTarget.showPicker()}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q3", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 5. Birth Place */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q4'
              label={Text({
                tid: "STUDENT_PT1_Q4",
                def: "Birth Place",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q4", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 6. Rishi-Gotra */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q7'
              label={Text({
                tid: "STUDENT_PT1_Q7",
                def: "Rishi-Gotra",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q7", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 7. Aadhaar Card Number */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q2'
              label={Text({
                tid: "STUDENT_PT1_Q2",
                def: "Aadhaar No.",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: /^[2-9]{1}[0-9]{11}$/, // Aadhaar must be 12 digits and should not start with 0 or 1
                  message: Text({
                    tid: "aadhaar_card_validation",
                    def: "Aadhaar must be 12 digits and should not start with 0 or 1",
                  }),
                },
              ]}
            >
              <Input
                maxLength={12}
                onKeyDown={allowOnlyNumericInput_onKeyDown}
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q2", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 8. Address for correspondence with PIN code */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={12}
          >
            <Form.Item
              name='STUDENT_PT1_Q10'
              label={Text({
                tid: "STUDENT_PT1_Q10",
                def: "Address for correspondence with PIN code",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("STUDENT_PT1_Q10", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("STUDENT_PT1_Q10", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='STUDENT_PT1_Q10'
            />
          </Col>
        </Row>
        {/* 9. Your mobile number */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q11'
              label={Text({
                tid: "STUDENT_PT1_Q11",
                def: "Your mobile number",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: Regex.MOBILENO, // Updated pattern
                  message: Text({
                    tid: "mobile_number_validation",
                    def: "Enter a valid 10-digit mobile number",
                  }),
                },
              ]}
            >
              <Input
                maxLength={10}
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q11", e.target.value)
                }
                onKeyDown={allowOnlyNumericInput_onKeyDown}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 10. Your email ID */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q12'
              label={Text({
                tid: "STUDENT_PT1_Q12",
                def: "Your email ID",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: Text({
                    tid: "VALID_EMAIL",
                    def: "VALID_EMAIL",
                  }),
                },
              ]}
            >
              <Input
                type='email'
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange(
                    "STUDENT_PT1_Q12",
                    e.target.value.toLowerCase()
                  )
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 11 In which language should the relevant conversation be conducted with you? */}
        <Row>
          <Col
            xs={24}
            lg={24}
            xl={24}
          >
            <Form.Item
              name='STUDENT_PT1_Q15'
              label={Text({
                tid: "STUDENT_PT1_Q15",
                def: "In which language should the relevant conversation be conducted with you?",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Radio.Group
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange(
                    "STUDENT_PT1_Q15",
                    (e.target as HTMLInputElement).value
                  )
                }
              >
                <Radio value='English'>
                  {Text({ tid: "ENGLISH", def: "English" })}
                </Radio>
                <Radio value='हिन्दी'>
                  {Text({ tid: "HINDI", def: "Hindi" })}
                </Radio>
                <Radio value='संस्कृतम्'>
                  {Text({ tid: "SANSKRIT", def: "Sanskrit" })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        {/* 12. Where do you live? (select one) */}
        <Row>
          <Col
            xs={24}
            lg={24}
            xl={24}
          >
            <Form.Item
              name='STUDENT_PT1_Q9'
              label={Text({
                tid: "STUDENT_PT1_Q9",
                def: "Where do you live? (select one)",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Radio.Group
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange(
                    "STUDENT_PT1_Q9",
                    (e.target as HTMLInputElement).value
                  )
                }
              >
                <Radio value='VEDA_SCHOOL'>
                  {Text({ tid: "VEDA_SCHOOL", def: "VEDA_SCHOOL" })}
                </Radio>
                <Radio value='GURUKUL'>
                  {Text({ tid: "GURUKUL", def: "GURUKUL" })}
                </Radio>
                <Radio value='PATRIARCHAL_HOME'>
                  {Text({ tid: "PATRIARCHAL_HOME", def: "PATRIARCHAL_HOME" })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        {/* 13. Are you married? */}
        <Row>
          <Col
            xs={24}
            lg={24}
            xl={24}
          >
            <Form.Item
              name='STUDENT_PT1_Q8'
              label={Text({
                tid: "STUDENT_PT1_Q8",
                def: "Are you married?",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Radio.Group
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange(
                    "STUDENT_PT1_Q8",
                    (e.target as HTMLInputElement).value
                  )
                }
              >
                <Radio value={eYES_OR_NO.YES}>
                  {Text({ tid: "MARRIED", def: "MARRIED" })}
                </Radio>
                <Radio value={eYES_OR_NO.NO}>
                  {Text({ tid: "UNMARRIED", def: "UNMARRIED" })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        {/* 14. Name of the present Veda teacher/Guruji */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q13'
              label={Text({
                tid: "STUDENT_PT1_Q13",
                def: "Name of the present Veda teacher/Guruji",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q13", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 15. Guruji's mobile number */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q14'
              label={Text({
                tid: "STUDENT_PT1_Q14",
                def: "Guruji's mobile number",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: Regex.MOBILENO, // Updated pattern
                  message: Text({
                    tid: "mobile_number_validation",
                    def: "Enter a valid 10-digit mobile number",
                  }),
                },
              ]}
            >
              <Input
                maxLength={10}
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q14", e.target.value)
                }
                onKeyDown={allowOnlyNumericInput_onKeyDown}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* 16. The Vedas studied: */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q16'
              label={Text({
                tid: "STUDENT_PT1_Q16",
                def: "The Vedas studied:",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Select
                disabled={disabled}
                onChange={(value) => {
                  handleFieldChange("STUDENT_PT1_Q16", value);
                  setVedOptions(vedMapping);
                  form.setFieldsValue({ STUDENT_PT1_Q17: "" });
                }}
                placeholder={DROPDOWN_PLACEHOLDER}
              >
                {vedOptions &&
                  Object.keys(vedOptions).map((ved) => (
                    <Select.Option
                      key={ved}
                      value={ved}
                    >
                      {ved}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* 17. Vedshakha : */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q17'
              label={Text({
                tid: "STUDENT_PT1_Q17",
                def: "STUDENT_PT1_Q17",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Select
                disabled={disabled}
                onChange={(value) =>
                  handleFieldChange("STUDENT_PT1_Q17", value)
                }
                placeholder={DROPDOWN_PLACEHOLDER}
              >
                {vedOptions &&
                  form.getFieldValue("STUDENT_PT1_Q16") &&
                  vedOptions[
                    form.getFieldValue("STUDENT_PT1_Q16")
                  ]?.vedashakhas.map((vedashakha: string) => (
                    <Select.Option
                      key={vedashakha}
                      value={vedashakha}
                    >
                      {vedashakha}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* 18. swa-ved shakha: */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='STUDENT_PT1_Q18'
              label={Text({
                tid: "STUDENT_PT1_Q18",
                def: "STUDENT_PT1_Q18",
              })}
              // rules={[
              //   {
              //     required: true,
              //     message: Text({ tid: "REQUIRED", def: "Required" }),
              //   },
              // ]}
            >
              <Select
                disabled={disabled}
                onChange={(value) =>
                  handleFieldChange("STUDENT_PT1_Q18", value)
                }
                placeholder={DROPDOWN_PLACEHOLDER}
              >
                {samvedShakhaOptions &&
                  samvedShakhaOptions.map((item: string) => (
                    <Select.Option
                      key={item}
                      value={item}
                    >
                      {item}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* 19. यदि एक से अधिक वेदशाखा का अध्ययन किया है तो वेदशाखा के नाम */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={12}
          >
            <Form.Item
              name='STUDENT_PT1_Q19'
              label={Text({
                tid: "STUDENT_PT1_Q19",
                def: "STUDENT_PT1_Q19",
              })}
              // rules={[
              //   {
              //     required: true,
              //     message: Text({ tid: "REQUIRED", def: "Required" }),
              //   },
              // ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q19", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 20. QUESTION 20 HEADING : */}
        <Row>
          <Col>
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT1_Q20_HEADING",
                def: "STUDENT_PT1_Q20_HEADING",
              })}
            </Typography.Text>
          </Col>
        </Row>
        {/* QUESTION 20 QUESTIONS EXAM_NAME, EXAM_YEAR, EXAM_CATEGORY, EXAM_PLACE, CERTIFICATE */}
        <Row className='QuestionsSubSection'>
          <Col
            xs={24}
            lg={12}
            xl={12}
          >
            {/* EXAM_NAME */}
            <Form.Item
              name='STUDENT_PT1_Q20_EXAM_NAME'
              label={Text({
                tid: "STUDENT_PT1_Q20_EXAM_NAME",
                def: "STUDENT_PT1_Q20_EXAM_NAME",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) => {
                  handleFieldChange(
                    "STUDENT_PT1_Q20_EXAM_NAME",
                    e.target.value
                  );
                }}
              />
            </Form.Item>
            {/* EXAM_YEAR */}
            <Form.Item
              name='STUDENT_PT1_Q20_EXAM_YEAR'
              label={Text({
                tid: "STUDENT_PT1_Q20_EXAM_YEAR",
                def: "STUDENT_PT1_Q20_EXAM_YEAR",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <DatePicker
                disabled={disabled}
                format='YYYY'
                onKeyDown={(e) => e.preventDefault()}
                picker='year'
                onChange={(date, dateString) =>
                  handleFieldChange("STUDENT_PT1_Q20_EXAM_YEAR", dateString)
                }
              />
            </Form.Item>
            {/* EXAM_CATEGORY */}
            <Form.Item
              name='STUDENT_PT1_Q20_EXAM_CATEGORY'
              label={Text({
                tid: "STUDENT_PT1_Q20_EXAM_CATEGORY",
                def: "STUDENT_PT1_Q20_EXAM_CATEGORY",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) => {
                  handleFieldChange(
                    "STUDENT_PT1_Q20_EXAM_CATEGORY",
                    e.target.value
                  );
                }}
              />
            </Form.Item>
            {/* EXAM_PLACE */}
            <Form.Item
              name='STUDENT_PT1_Q20_EXAM_PLACE'
              label={Text({
                tid: "STUDENT_PT1_Q20_EXAM_PLACE",
                def: "STUDENT_PT1_Q20_EXAM_PLACE",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) => {
                  handleFieldChange(
                    "STUDENT_PT1_Q20_EXAM_PLACE",
                    e.target.value
                  );
                }}
              />
            </Form.Item>
            {/* EXAM_CERTIFICATE */}
            <Form.Item
              name='STUDENT_PT1_Q20_EXAM_CERTIFICATE'
              label={Text({
                tid: "STUDENT_PT1_Q20_EXAM_CERTIFICATE",
                def: "STUDENT_PT1_Q20_EXAM_CERTIFICATE",
              })}
              rules={[
                {
                  required:
                    attachmentId ||
                    (documentsData?.length &&
                      documentsData.find(
                        (doc: any) =>
                          doc.labelName === "STUDENT_PT1_Q20_EXAM_CERTIFICATE"
                      ))
                      ? false
                      : true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                type='file'
                disabled={disabled}
                accept='.jpg,.jpeg,.png,.pdf'
                // onChange={(e) => {
                //   if (e.target.files && e.target.files[0]) {
                //     uploadDocument(
                //       e.target.files[0],
                // eDocType.OTHER,
                // "STUDENT_PT1_Q20"
                //     );
                //   }
                // }}
                onChange={(e) => {
                  const file = e?.target?.files?.[0];
                  if (!validateFile(file as File)?.valid) {
                    onShowToast({
                      type: ToastType.error,
                      title: <CloseOutlined />,
                      position: ToastOpen.leftBottom,
                      content: validateFile(file as File).error,
                    });
                    e.target.value = "";
                    form.resetFields(["STUDENT_PT1_Q20_EXAM_CERTIFICATE"]);
                  } else if (file) {
                    uploadDocument(
                      file,
                      eDocType.OTHER,
                      "STUDENT_PT1_Q20_EXAM_CERTIFICATE"
                    );
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24}>
            {attachmentId ? (
              <div className='previewLink'>
                <span>
                  {Text({
                    tid: "ATTACHED_DOCUMENT",
                    def: "Attached Document",
                  })}
                  :
                </span>
                <a
                  href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${attachmentId}`}
                  target='_blank'
                  rel='noreferrer'
                  className='primary-link'
                >
                  {Text({
                    tid: "PREVIEW",
                    def: "Preview",
                  })}
                </a>
              </div>
            ) : (
              documentsData &&
              documentsData.length > 0 &&
              documentsData
                .filter(
                  (doc: any) =>
                    doc.labelName === "STUDENT_PT1_Q20_EXAM_CERTIFICATE"
                )
                .map((doc: any) => (
                  <div className='previewLink'>
                    <span>
                      {Text({
                        tid: "ATTACHED_DOCUMENT",
                        def: "Attached Document",
                      })}
                      :
                    </span>
                    <a
                      href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                      target='_blank'
                      rel='noreferrer'
                      className='primary-link'
                    >
                      {doc.docName}
                    </a>
                  </div>
                ))
            )}
          </Col>
        </Row>

        {/* 21. अपने वर्तमान / अन्तिम वेदाध्यापक व वेदविद्यालय के नाम जहाँ आपने वेदाध्ययन किया: */}
        <Row>
          <Col>
            <Typography.Text>
              {Text({
                tid: "STUDENT_PT1_Q21_HEADING",
                def: "STUDENT_PT1_Q21_HEADING",
              })}
            </Typography.Text>
          </Col>
        </Row>
        {/* 22.  */}
        <Row className='QuestionsSubSection'>
          <Col
            xs={24}
            lg={12}
            xl={12}
          >
            <Form.Item
              name='STUDENT_PT1_Q21'
              label={Text({
                tid: "STUDENT_PT1_Q21",
                def: "STUDENT_PT1_Q21",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q21", e.target.value)
                }
              />
            </Form.Item>
            <Form.Item
              name='STUDENT_PT1_Q22'
              label={Text({
                tid: "STUDENT_PT1_Q22",
                def: "STUDENT_PT1_Q22",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("STUDENT_PT1_Q22", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 23. आप किस स्तर तक वेदाध्ययन करना चाहते हैं */}
        <Row>
          <Col xs={24}>
            <Form.Item
              name='STUDENT_PT1_Q23'
              label={Text({
                tid: "STUDENT_PT1_Q23",
                def: "STUDENT_PT1_Q23",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("STUDENT_PT1_Q23", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("STUDENT_PT1_Q23", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='STUDENT_PT1_Q23'
            />
          </Col>
        </Row>
        {/* 24. क्या आप पौरोहित्य / अर्चकत्व में रुचि रखते हैं?*/}
        <Row>
          <Row>
            <Col
              xs={24}
              lg={24}
              xl={24}
            >
              <Form.Item
                name='STUDENT_PT1_Q24'
                label={Text({
                  tid: "STUDENT_PT1_Q24",
                  def: "STUDENT_PT1_Q24",
                })}
                rules={[
                  {
                    required: true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Radio.Group
                  disabled={disabled}
                  onBlur={(e) =>
                    handleFieldChange(
                      "STUDENT_PT1_Q24",
                      (e.target as HTMLInputElement).value
                    )
                  }
                >
                  <Radio value={eYES_OR_NO.YES}>
                    {Text({ tid: "YES", def: "YES" })}
                  </Radio>
                  <Radio value={eYES_OR_NO.NO}>
                    {Text({ tid: "NO", def: "NO" })}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Row>
        {/* 25. आप आगे चलकर क्या बनना चाहते हैं */}
        <Row>
          <Col xs={24}>
            <Form.Item
              name='STUDENT_PT1_Q25'
              label={Text({
                tid: "STUDENT_PT1_Q25",
                def: "STUDENT_PT1_Q25",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("STUDENT_PT1_Q25", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("STUDENT_PT1_Q25", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='STUDENT_PT1_Q25'
            />
          </Col>
        </Row>
        {/* 26. आप कौनसा व्यवसाय आजीविका के रूप में करना चाहते हैं? */}
        <Row>
          <Col xs={24}>
            <Form.Item
              name='STUDENT_PT1_Q26'
              label={Text({
                tid: "STUDENT_PT1_Q26",
                def: "STUDENT_PT1_Q26",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <>
                <Input
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("STUDENT_PT1_Q26", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("STUDENT_PT1_Q26", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
          </Col>
        </Row>
        {/* 27. आपको यह पुरस्कार क्यों दिया जाए? सप्रमाण पाँच प्रमुख कारण बतायें। (चार पंक्तियों अपना उत्तर दीजिये) */}
        <Row>
          <Col xs={24}>
            <Form.Item
              name='STUDENT_PT1_Q27'
              label={Text({
                tid: "STUDENT_PT1_Q27",
                def: "STUDENT_PT1_Q27",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
              ]}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("STUDENT_PT1_Q27", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("STUDENT_PT1_Q27", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='STUDENT_PT1_Q27'
            />
          </Col>
        </Row>

        <div
          id='student_part_one_affidavit'
          className='affidavitSection'
        >
          <Row>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "AFFIDAVIT_TITLE",
                  def: "AFFIDAVIT TITLE",
                })}
              </Typography.Text>
            </Col>
          </Row>
          <Row className='affidavitRow'>
            <Col xs={24}>
              {Text({ tid: "I", def: "I" })}
              <Form.Item
                name='STUDENT_PT1_Q28'
                style={{
                  maxWidth: "200px",
                }}
                className='affidavitRowInput'
                // rules={[
                //   {
                //     required: true,
                //     message: Text({ tid: "REQUIRED", def: "Required" }),
                //   },
                // ]}
              >
                <Input
                  disabled={applyPdfStyles ? false : true}
                  onBlur={(e) =>
                    handleFieldChange("STUDENT_PT1_Q28", e.target.value)
                  }
                  id={applyPdfStyles ? "affidavit_input" : ""}
                />
              </Form.Item>
              {Text({
                tid: "student_affidavit_line_1",
                def: "student_affidavit_line_1",
              })}
            </Col>
          </Row>
          <Col xs={24}>
            <ul className='mb-label'>
              <li>
                <Typography.Text>
                  {Text({
                    tid: "AFFIDAVIT_CLAUSE_1",
                    def: "AFFIDAVIT_CLAUSE_1",
                  })}
                </Typography.Text>
              </li>

              <li>
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "AFFIDAVIT_CLAUSE_2",
                    def: "AFFIDAVIT_CLAUSE_2",
                  })}
                </Typography.Text>
              </li>
              <li>
                <Typography.Text type='secondary'>
                  {Text({
                    tid: "AFFIDAVIT_CLAUSE_3",
                    def: "AFFIDAVIT_CLAUSE_3",
                  })}
                </Typography.Text>
              </li>
            </ul>

            <Typography.Text>
              {Text({
                tid: "AFFIDAVIT_VERIFICATION",
                def: "AFFIDAVIT_VERIFICATION",
              })}
            </Typography.Text>

            <Typography.Text>
              {Text({
                tid: "AFFIDAVIT_UNDERSTANDING",
                def: "AFFIDAVIT_UNDERSTANDING",
              })}
            </Typography.Text>
            <Typography.Text>
              {Text({
                tid: "AFFIDAVIT_ACCEPTANCE",
                def: "AFFIDAVIT_ACCEPTANCE",
              })}
            </Typography.Text>
          </Col>
          <Row className='QuestionsSubSection affidavitQuestionFirst'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "FULL_NAME_OF_APPLICANT",
                      def: "FULL_NAME_OF_APPLICANT",
                    })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT1_Q30'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      value={form.getFieldValue("STUDENT_PT1_Q1") || ""}
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT1_Q30'
                  label={Text({
                    tid: "FULL_NAME_OF_APPLICANT",
                    def: "FULL_NAME_OF_APPLICANT",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={applyPdfStyles ? false : true}
                    value={form.getFieldValue("STUDENT_PT1_Q1") || ""}
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row className='QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "PLACE",
                      def: "PLACE",
                    })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT1_Q31'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      onBlur={(e) =>
                        handleFieldChange("STUDENT_PT1_Q31", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT1_Q31'
                  label={Text({
                    tid: "PLACE",
                    def: "PLACE",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("STUDENT_PT1_Q31", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row className='QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "DATE",
                      def: "DATE",
                    })}
                  </span>
                  <Form.Item
                    name='STUDENT_PT1_Q32'
                    rules={[
                      {
                        required: true,
                        message: Text({ tid: "REQUIRED", def: "Required" }),
                      },
                    ]}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      type={undefined}
                      onChange={(e) =>
                        handleFieldChange("STUDENT_PT1_Q32", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='STUDENT_PT1_Q32'
                  label={Text({
                    tid: "DATE",
                    def: "DATE",
                  })}
                  rules={[
                    {
                      required: true,
                      message: Text({ tid: "REQUIRED", def: "Required" }),
                    },
                  ]}
                >
                  <Input
                    disabled={disabled}
                    type={applyPdfStyles ? undefined : "date"}
                    max={disableFutureDates_on_input_date_max()}
                    onChange={(e) =>
                      handleFieldChange("STUDENT_PT1_Q32", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          {applyPdfStyles ? (
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "SIGNATURE_OF_THE_APPLICANT",
                      def: "SIGNATURE_OF_THE_APPLICANT",
                    })}
                  </span>
                  <Form.Item style={{ marginBottom: 0, flex: 1 }}>
                    <Input id={applyPdfStyles ? "affidavit_input" : ""} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          ) : null}
        </div>
        <div className='affidavitSection'>
          {!disabled && (
            <Row className='mb-15 QuestionsSubSection'>
              <Button
                type='default'
                onClick={handleGeneratePDF}
                className='downloadAffidavitButton'
              >
                {Text({
                  tid: "DOWNLOAD_AFFIDAVIT",
                  def: "Download affidavit",
                })}
              </Button>
            </Row>
          )}
          <Row className=' QuestionsSubSection'>
            <Col
              xs={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='STUDENT_PT1_Q29'
                label={Text({
                  tid: "UPLOAD_AFFIDAVIT",
                  def: "Upload affidavit",
                })}
                rules={[
                  {
                    required:
                      signatureId ||
                      (documentsData?.length &&
                        documentsData.find(
                          (doc: any) => doc.labelName === "STUDENT_PT1_Q29"
                        ))
                        ? false
                        : true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  type='file'
                  disabled={disabled}
                  // onChange={(e) => {
                  //   if (e.target.files && e.target.files[0]) {
                  //     uploadDocument(
                  //       e.target.files[0],
                  // eDocType.OTHER,
                  // "STUDENT_PT1_Q29"
                  //     );
                  //   }
                  // }}
                  accept='.jpg,.jpeg,.png,.pdf'
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!validateFile(file as File).valid) {
                      onShowToast({
                        type: ToastType.error,
                        title: <CloseOutlined />,
                        position: ToastOpen.leftBottom,
                        content: validateFile(file as File).error,
                      });
                      e.target.value = "";
                      form.resetFields(["STUDENT_PT1_Q29"]);
                    } else if (file) {
                      uploadDocument(file, eDocType.OTHER, "STUDENT_PT1_Q29");
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              {signatureId ? (
                <div className='previewLink'>
                  <span>
                    {Text({
                      tid: "ATTACHED_DOCUMENT",
                      def: "Attached Document",
                    })}
                    :
                  </span>
                  <a
                    href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${signatureId}`}
                    target='_blank'
                    rel='noreferrer'
                    className='primary-link'
                  >
                    {Text({
                      tid: "PREVIEW",
                      def: "Preview",
                    })}
                  </a>
                </div>
              ) : (
                documentsData &&
                documentsData.length > 0 &&
                documentsData
                  .filter((doc: any) => doc.labelName === "STUDENT_PT1_Q29")
                  .map((doc: any) => (
                    <div className='previewLink mb-30'>
                      <span>
                        {Text({
                          tid: "ATTACHED_DOCUMENT",
                          def: "Attached Document",
                        })}
                        :
                      </span>
                      <a
                        href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                        target='_blank'
                        rel='noreferrer'
                        className='primary-link'
                      >
                        {doc.docName}
                      </a>
                    </div>
                  ))
              )}
            </Col>
          </Row>
        </div>
        <Row
          style={
            disabled === true
              ? { marginTop: "var(--bs-item-negative-margin-30)" }
              : undefined
          }
        >
          {disabled === false && (
            <Button
              block
              type='primary'
              htmlType='submit'
              disabled={isLoading || disabled || isUploading}
              className='formSubmitButton'
              loading={isSubmitting}
            >
              {Text({ tid: "SUBMIT", def: "SUBMIT" })}
            </Button>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default StudentPartOne;
